/**
 * Moved vcalendar loading to a dedicated file to:
 *
 * 1. Enforce sepration of concerns
 * 2. Only load the required `v-date-picker` component (not entire library)
 *
 * @author AtomicSmash
 */
import Vue from "vue";
import { setupCalendar, DatePicker } from "v-calendar";

// Setup calendar defaults (formally passed to `Vue.use` function)
setupCalendar({
    datePickerTintColor: '#F3BD47',
    themeStyles: {
        wrapper: {
            backgroundColor: '#FFFFFF',
            border: 'none'
        },
        dayCell: {
            fontSize: "2rem"
        },
        dayContent: {
            color: "#A9A9A9",
            fontWeight: 600,
            borderRadius: "0"
        },
        headerTitle: {
            textTransform: 'uppercase',
            fontSize: '16px'
        },
        dayCellNotInMonth: {
            cursor: 'not-allowed',
        }
      },
      datePickerShowDayPopover: false,
      datePickerDisabledAttribute: {
          contentStyle: ({ isHovered }: { isHovered: boolean }) => ({
              color: '#BFBFBF',
              backgroundColor: '#F2F2F2',
              fontWeight: 400,
              opacity: 1,
              borderRadius: '0',
              ...(isHovered && {
                  cursor: 'not-allowed'
              }),
        }),
    }
});

// Register <v-date-picker> component
Vue.component("v-date-picker", DatePicker);
